module.exports = __webpack_public_path__ + "static/media/check.00492d49.svg";